class QuickAddToCart extends HTMLElement {
  constructor() {
    super();
    this.btnAddToCart = this.querySelector('button.add-to-cart');
    this.isInSlider = this.getAttribute('data-is-slider') === 'true';
    this.btnIcons = {
      plus: this.btnAddToCart.querySelector('.qatc__icon-plus'),
      minus: this.btnAddToCart.querySelector('.qatc__icon-minus'),
    };
    this.btnLabels = {
      primary: this.getAttribute('data-primary-btn-label') || 'ADD TO CART',
      secondary:
        this.getAttribute('data-secondary-btn-label') || 'ADDED TO CART',
    };
    this.variantPickerContainer =
      this.querySelector('.qatc__variants-container') || null;
    this.handle = this.getAttribute('data-product-handle');
    this.product = null;

    this.btnAddToCart.addEventListener('click', this.onCLickToAdd);
    if (this.variantPickerContainer) {
      document.addEventListener('click', this.onClickOutside);

      this.variantPickerContainer
        .querySelectorAll('.qatc__variant:not(.qatc__variant-disabled)')
        .forEach((variantEl) =>
          variantEl.addEventListener('click', this.onVariantClick),
        );

      this.customSelects =
        this.variantPickerContainer.querySelectorAll('custom-select');

      this.variantAddBtn = this.querySelector('.add-variant-to-cart');

      if (this.customSelects.length && this.variantAddBtn) {
        this.customSelects.forEach((customSelectEl) =>
          customSelectEl.addEventListener('change', this.onOptionChange),
        );

        this.onOptionChange();

        this.variantAddBtn?.addEventListener('click', this.onClickAddVariant);
      }
    }
    if (this.isInSlider) {
      document.addEventListener('resize', this.hideVariantPicker);
      document.addEventListener(
        'custom-event:update-position',
        this.updateContainerPosition,
      );
      document.addEventListener('custom-event:close', this.hideVariantPicker);
    }
  }

  getPositionAndSize = () => {
    const rect = this.getBoundingClientRect();
    return {
      left: rect.left,
      top: rect.bottom,
      width: this.offsetWidth,
    };
  };

  getProductData = async () => {
    if (!this.handle) {
      return null;
    }

    try {
      return await fetch(`/products/${this.handle}.js`).then((res) =>
        res.json(),
      );
    } catch (e) {
      console.error(e);

      return null;
    }
  };

  onCLickToAdd = async (e) => {
    e.preventDefault();
    const el = e.currentTarget;

    const product = this.product || (await this.getProductData());

    if (!product) {
      return;
    }

    if (this.toggleVariantPicker()) {
      return;
    }

    this.toggleBtnState({ el, className: 'btn--loading' });

    const firsVariant = product.variants.find((variant) => variant.available);
    if (!firsVariant) {
      this.toggleBtnState({ el, className: 'btn--loading', disabled: false });
      return;
    }

    const addResponse = await this.onAddToCart({
      quantity: 1,
      variantId: firsVariant.id,
    });

    this.toggleBtnState({ el, className: 'btn--loading', disabled: false });
    if (addResponse) {
      this.toggleBtnState({ el, className: 'btn--added', disabled: false });
      this.toggleBtnAddText({ textValue: this.btnLabels.secondary });
      setTimeout(() => {
        this.toggleBtnState({ el, className: 'btn--added', disabled: false });
        this.toggleBtnAddText({ textValue: this.btnLabels.primary });
      }, 2000);
      document.dispatchEvent(new Event('cart:build'));
      document.dispatchEvent(new Event('cart:open'));
    }
  };

  onVariantClick = async (e) => {
    const el = e.currentTarget;
    this.toggleBtnState({
      el,
      className: 'qatc__variant--loading',
    });
    const variantId = Number(el.getAttribute('data-variant-id')) || null;
    if (!variantId) {
      this.toggleBtnState({
        el,
        className: 'qatc__variant--loading',
        disabled: false,
      });
      return;
    }

    const product = this.product || (await this.getProductData());

    if (!product) {
      this.toggleBtnState({
        el,
        className: 'qatc__variant--loading',
        disabled: false,
      });
      return;
    }

    const variantExist = product.variants.some(
      (variant) => variant.id === variantId,
    );
    if (!variantExist) {
      this.toggleBtnState({
        el,
        className: 'qatc__variant--loading',
        disabled: false,
      });
      return;
    }

    const addResponse = await this.onAddToCart({
      quantity: 1,
      variantId: variantId,
    });

    if (addResponse) {
      this.toggleBtnState({
        el,
        className: 'qatc__variant--added',
      });
      this.toggleBtnState({
        el: this.btnAddToCart,
        className: 'btn--added',
        disabled: false,
      });
      this.toggleBtnAddText({ textValue: this.btnLabels.secondary });
      setTimeout(() => {
        this.toggleBtnState({
          el,
          className: 'qatc__variant--added',
          disabled: false,
        });
        this.toggleBtnState({
          el: this.btnAddToCart,
          className: 'btn--added',
          disabled: false,
        });
        this.toggleBtnAddText({ textValue: this.btnLabels.primary });
      }, 2000);
      document.dispatchEvent(new Event('cart:build'));
      document.dispatchEvent(new Event('cart:open'));
    } else {
      el.classList.add('qatc__variant-disabled');
    }

    this.toggleBtnState({ el, className: 'qatc__variant--loading' });
  };

  onClickAddVariant = async (e) => {
    const el = e.currentTarget;

    if (!this.selectedVariant) {
      return;
    }

    this.setBtnState({
      el,
      className: 'btn--loading',
      remove: false,
    });

    const addResponse = await this.onAddToCart({
      quantity: 1,
      variantId: this.selectedVariant.id,
    });

    if (addResponse) {
      this.toggleBtnState({
        el,
        className: 'btn--added',
      });
      this.toggleBtnState({
        el: this.btnAddToCart,
        className: 'btn--added',
        disabled: false,
      });
      this.toggleBtnAddText({ textValue: this.btnLabels.secondary });
      setTimeout(() => {
        this.toggleBtnState({
          el,
          className: 'btn--added',
          disabled: false,
        });
        this.toggleBtnState({
          el: this.btnAddToCart,
          className: 'btn--added',
          disabled: false,
        });
        this.toggleBtnAddText({ textValue: this.btnLabels.primary });
      }, 2000);
      document.dispatchEvent(new Event('cart:build'));
      document.dispatchEvent(new Event('cart:open'));
    }

    this.setBtnState({
      el,
      className: 'btn--loading',
      remove: true,
    });
  };

  onOptionChange = async () => {
    const product = this.product || (await this.getProductData());
    const optionValues = [];

    this.customSelects.forEach((customSelect) => {
      const optionPosition =
        Number(customSelect.getAttribute('data-option-position')) || 1;
      optionValues[optionPosition - 1] = customSelect.value;
    });

    const selectedVariant = product.variants.find(
      (variant) =>
        this.arrayChecker({ arr1: variant.options, arr2: optionValues }) &&
        variant.available,
    );

    if (!selectedVariant) {
      this.setBtnState({
        el: this.variantAddBtn,
        className: 'btn--secondary',
        remove: false,
      });
      this.selectedVariant = null;
      return;
    }

    this.selectedVariant = selectedVariant;

    this.setBtnState({
      el: this.variantAddBtn,
      className: 'btn--secondary',
      remove: true,
    });

    this.variantAddBtn.querySelector(
      '.qatc__add-variant-to-cart-price',
    ).innerHTML = this.convertToMoney({
      amount: selectedVariant.price,
    });
  };

  toggleBtnState = ({ el, className, disabled = true }) => {
    el.classList.toggle(className);
    el.disabled = disabled;
  };

  setBtnState = ({ el, className, disabled = false, remove = false }) => {
    if (remove) {
      el.classList.remove(className);
    } else {
      el.classList.add(className);
    }
    el.disabled = disabled;
  };

  toggleBtnAddText = ({ textValue }) => {
    const spanLabel = this.btnAddToCart.querySelector('.add-to-cart-label');
    if (!spanLabel) {
      return;
    }

    spanLabel.innerHTML = textValue;
  };

  handleDOMResize = () => this.updateContainerPosition();

  handleDOMScroll = () => this.updateContainerPosition();

  updateContainerPosition = () => {
    if (!this.variantPickerContainer) {
      return;
    }
    const position = this.getPositionAndSize();
    this.variantPickerContainer.style.position = 'fixed';
    this.variantPickerContainer.style.left = `${position.left}px`;
    this.variantPickerContainer.style.top = `${position.top}px`;
    this.variantPickerContainer.style.width = `${position.width}px`;
  };

  toggleVariantPicker = () => {
    if (!this.variantPickerContainer) {
      return false;
    }

    if (this.isInSlider) {
      this.updateContainerPosition();
    }

    this.variantPickerContainer.classList.toggle(
      'qatc__variants-container-active',
    );

    this.btnIcons?.plus?.classList.toggle('hide');
    this.btnIcons?.minus?.classList.toggle('hide');

    return true;
  };

  hideVariantPicker = () => {
    if (!this.variantPickerContainer) {
      return false;
    }

    this.variantPickerContainer.classList.remove(
      'qatc__variants-container-active',
    );

    this.btnIcons?.plus?.classList.remove('hide');
    this.btnIcons?.minus?.classList.add('hide');

    return true;
  };

  onClickOutside = (e) => {
    const el = e.target;
    if (el !== this && !this.contains(el)) {
      this.hideVariantPicker();
    }
  };

  onAddToCart = async ({ quantity, variantId }) => {
    if (!quantity || !variantId) {
      return false;
    }

    try {
      const formData = { items: [] };

      formData.items.push({
        id: variantId,
        quantity: quantity,
      });

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      }).then((res) => res.json());

      return addResponse && addResponse?.items?.length > 0;
    } catch (e) {
      console.error(e);

      return false;
    }
  };

  convertToMoney = ({ amount }) => {
    const value = amount / 100;
    const locale = `${window?.Shopify?.locale || 'en'}-${window?.Shopify?.country || 'US'}`;
    const currency = window?.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
    }).format(value);
  };

  arrayChecker = ({ arr1, arr2 }) => {
    if (arr1 === arr2) return true; // same reference
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
    if (arr1.length !== arr2.length) return false;

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    return true;
  };
}

if (!customElements.get('quick-add-to-cart')) {
  customElements.define('quick-add-to-cart', QuickAddToCart);
}
